import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb'
import Chip from '@mui/material/Chip'
import {grey, indigo} from '@mui/material/colors'
import {useAppNavigate} from 'app/hooks/navigation/useAppNavigate'
import {IConcept} from 'app/models/concept'
import {ISavedSearchConcept} from 'app/models/saved_search'
import {emInstanceOf} from 'utilities/extensionMethods'

interface Props {
  concept: ISavedSearchConcept | IConcept
  link?: string
  width?: 'auto' | 'min-content' | 'max-content' | 'fit-content'
  fs?: string
  color?: string
  ignore?: boolean
}

export const SmallConceptChip = ({concept, link, width, fs, color, ignore}: Props) => {
  const conDetails: ISavedSearchConcept | undefined = emInstanceOf<ISavedSearchConcept>(
    concept,
    'id'
  )
    ? concept
    : undefined
  const con: IConcept | undefined = emInstanceOf<IConcept>(concept, 'qid') ? concept : undefined
  const chipLink = link
    ? link
    : `/concepts/detail?externalId=${conDetails ? conDetails.id : con?.id}`

  const navigate = useAppNavigate()
  return (
    <Chip
      component={'span'}
      label={conDetails ? conDetails.name : con?.name}
      onClick={() => navigate(chipLink)}
      icon={ignore ? <DoNotDisturbIcon color={'error'} /> : undefined}
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        margin: '0 !important',
        flexDirection: 'row',
        height: 'auto',
        m: 0.5,
        fontSize: fs ? fs : '.8rem',
        borderRadius: '2em',
        width: width ? width : '100%',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        boxShadow:
          'rgba(0, 0, 0, 0.3) 0px 1px 2px, rgba(0, 0, 0, 0.2) 0px 3px 6px -1px, rgba(0, 0, 0, 0.1) 0px -1.8px 0px inset',
        bgcolor: color ? color : grey[50],
        '& .MuiChip-deleteIcon': {
          color: indigo[300],
          fontSize: '1rem',
        },
        '& .MuiChip-label': {
          fontSize: '1rem',
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          overflowWrap: 'break-word',
          whiteSpace: 'normal',
        },
      }}
    />
  )
}
